/**
 * Translation: NL - Api
 * Note, also export in translations/{LANGUAGE}/index.js
 */
export default {
  'api.follow': 'Volgen',
  'api.pending': 'Volgverzoek annuleren',
  'api.unfollow': 'Niet meer volgen',
  'api.register': 'Inschrijven',
  'api.unregister': 'Uitschrijven',
  'api.private.follow': 'Volgverzoek sturen',
  'api.community.message.following': 'Je volgt vanaf dit moment deze community.',
  'api.community.message.pending': 'Je aanvraag om deze community te volgen is in behandeling.',
  'api.community.message.not-following': 'Je volgt vanaf dit moment deze community niet meer.',
  'api.community.message.private.not-following': 'Je volgverzoek voor deze community is geannuleerd.',
  'api.community.user.message.removed': 'Je hebt de gebruiker verwijderd',
  'api.community.user.message.approved': 'Je hebt de gebruiker goedgekeurd',
  'api.community.user.message.promoted': 'Je hebt de gebruiker community - admin gemaakt',
  'api.community.user.message.demoted': 'Je hebt de community - admin aangepast naar een gebruiker',
  'api.community.comment.added': 'Je reactie is toegevoegd',
  'api.community.comment.removed': 'Je reactie is verwijderd',
  'api.community.comment.editted': 'Je reacties is aangepast',
  'api.community.comment.textarea.placeholder': 'Schrijf een opmerking...',
  'api.community.comment.edit': 'Wijzig opmerking',
  'api.community.comment.cancel': 'Annuleren',
  'api.community.message.liked': 'Je vindt dit bericht leuk',
  'api.community.message.unliked': 'Je vindt dit bericht niet meer leuk',
  'api.golfcourse.message.following': 'Je volgt vanaf dit moment deze golfbaan.',
  'api.golfcourse.message.not-following': 'Je volgt vanaf dit moment deze golfbaan niet meer.',
  'api.user.message.following': 'Je volgt vanaf dit moment deze gebruiker.',
  'api.user.message.not-following': 'Je volgt vanaf dit moment deze gebruiker niet meer.',
  'api.error.fail': 'Er is iets mis gegaan, probeer het nog een keer.',
  'api.confirm.user.delete': 'Weet je zeker dat je deze gebruiker wilt verwijderen?',
  'api.confirm.user.approve': 'Weet je zeker dat je deze gebruiker wilt goedkeuren?',
  'api.confirm.user.promote': 'Weet je zeker dat je deze gebruiker community - admin wilt maken?',
  'api.confirm.user.demote': 'Weet je zeker dat je van deze community - admin een gebruiker wilt maken?',
  'api.confirm.comment.remove': 'Weet je zeker dat je deze reactie wilt verwijderen?',
  'api.comments.from': 'van',
  'api.tournament.message.not-following': 'Je hebt je vanaf dit moment uitgeschreven voor het toernooi',
  'api.tournament.message.following': 'Je hebt je vanaf dit moment ingeschreven voor het toernooi',
};
